import type { TFunction } from "i18next"

import type { FeaturePropertiesType } from "types/geolocation.types"

import { featureProperties, featurePropertyUnits } from "helpers/utils/map"
import type { EntityPopupField } from "./EntityPopup"

// The card shows these in its header and ID row rather than as rows.
const HEADER_PROPERTIES = new Set(["kind", "name", "id", "less_id"])

/**
 * A card row for each property of the feature that has a value, in the order
 * the feature lists them. A popup draws a property its own way through `overrides`.
 */
export const getFeatureFields = (
  kind: keyof FeaturePropertiesType,
  properties: object,
  t: TFunction,
  overrides: Record<string, EntityPopupField> = {},
): EntityPopupField[] =>
  featureProperties[kind].flatMap((property): EntityPopupField[] => {
    if (HEADER_PROPERTIES.has(property)) return []
    if (overrides[property]) return [overrides[property]]

    const value = (properties as Record<string, unknown>)[property]
    const label = t(`geo_info.${property.toUpperCase()}`)
    if (typeof value === "number") {
      return [{ label, type: "number", value, unit: featurePropertyUnits[property] }]
    }
    if (typeof value === "string") {
      return [{ label, type: "text", value }]
    }
    return []
  })
